/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TaskTemplate } from './TaskTemplate';
import {
    TaskTemplateFromJSON,
    TaskTemplateFromJSONTyped,
    TaskTemplateToJSON,
    TaskTemplateToJSONTyped,
} from './TaskTemplate';

/**
 * List of task templates
 * @export
 * @interface TaskTemplateListResponse
 */
export interface TaskTemplateListResponse {
    /**
     * 
     * @type {Array<TaskTemplate>}
     * @memberof TaskTemplateListResponse
     */
    tasks: Array<TaskTemplate>;
}

/**
 * Check if a given object implements the TaskTemplateListResponse interface.
 */
export function instanceOfTaskTemplateListResponse(value: object): value is TaskTemplateListResponse {
    if (!('tasks' in value) || value['tasks'] === undefined) return false;
    return true;
}

export function TaskTemplateListResponseFromJSON(json: any): TaskTemplateListResponse {
    return TaskTemplateListResponseFromJSONTyped(json, false);
}

export function TaskTemplateListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskTemplateListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tasks': ((json['tasks'] as Array<any>).map(TaskTemplateFromJSON)),
    };
}

export function TaskTemplateListResponseToJSON(json: any): TaskTemplateListResponse {
    return TaskTemplateListResponseToJSONTyped(json, false);
}

export function TaskTemplateListResponseToJSONTyped(value?: TaskTemplateListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tasks': ((value['tasks'] as Array<any>).map(TaskTemplateToJSON)),
    };
}

